// extracted by mini-css-extract-plugin
export default {"card":"Card_card__vp0Mm","title":"Card_title__EruoY","text":"Card_text__ZAR5B"};